import React from 'react';
import { useParams } from 'react-router-dom';
import title from '../assets/title.png';

const Invite: React.FC = () => {
  const { path } = useParams();

  return (
    <div className="invite-page">
      <img src={title} className="invite-title" alt="Bye For Now" />
      <div className="invite-content">
        <a href={`byefornow://invite/${path}`}>
          <button className="store-button store-button-primary">
            Open in app (click if not automatic)
          </button>
        </a>
        <span className="invite-subtext">Don&apos;t have the app?</span>
        <div className="invite-stores">
          <a href="https://apps.apple.com/us/app/monogatari/id6502987623">
            <button className="store-button store-button-primary">
              Download on the App Store
            </button>
          </a>
          <a href="https://play.google.com/store/apps/details?id=org.monogatari.project">
            <button className="store-button store-button-primary">
              Get it on Google Play
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Invite;
